import { useEffect, useState } from 'react';
import {
  getTenantBrand,
  getTenantContext,
  onTenantContextChange,
} from '../services/tenantContextService';

/**
 * The tenant context, re-rendering when it loads.
 *
 * The context arrives asynchronously after login, so components that render
 * before it lands must show a sensible default and update in place rather than
 * flashing or crashing. Every hook here returns a usable empty value first.
 */
export function useTenantContext() {
  const [context, setContext] = useState(getTenantContext);

  useEffect(() => onTenantContextChange(setContext), []);

  return context;
}

/** Branding for the current tenant. `{}` until the context loads. */
export function useTenantBrand() {
  const [brand, setBrand] = useState(getTenantBrand);

  useEffect(() => onTenantContextChange((ctx) => setBrand(ctx?.brand || {})), []);

  return brand;
}

export default useTenantContext;
